import React from "react";
import { Link } from "react-router-dom";
import { GrDocumentMissing } from "react-icons/gr";
import Button from "../../../components/Button";

const CompleteProfile = () => {
  return (
    <div className="flex flex-col max-w-lg w-full bg-white mt-8 p-8 items-center rounded-xl shadow-xl border border-indigo-500">
      <GrDocumentMissing className="text-indigo-500 text-5xl mb-6" />

      <h2 className="text-2xl font-semibold text-center text-gray-900 mb-4">
        Complete your profile
      </h2>
      <p className="text-center text-gray-700 mb-4">
        Please complete your profile before registering for the event.
      </p>

      <Link to="/profile">
        <Button color="indigo">Check Profile</Button>
      </Link>
    </div>
  );
};

export default CompleteProfile;
